import { createContext, useContext } from "react";
import { ShareroomGuidecontroller } from "./shareroomGuidecontroller";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ShareroomGuidecontrollerContext = createContext<ShareroomGuidecontroller>(null as any);

export const useShareroomGuidecontroller = (): ShareroomGuidecontroller => useContext(ShareroomGuidecontrollerContext);
